import * as React from 'react';
import { useGumroadListener } from './useGumroadListener';
import { useSelector } from 'react-redux';
import { getUserProfile } from '../../containers/UserProfile/selectors';
import { FormattedMessage } from 'react-intl';
import Button, { IButtonProps } from '../Button';
import { GumroadProduct } from './index';
import { trackEvent } from '../../utils/Analytics';

interface SubscribeProps extends IButtonProps {
  readonly product: GumroadProduct;
  readonly messageId: string;
}

const setupGumRoadHook = (e: any) => {
  const currentHref = e.target!.href;
  const gumroadOverlay = (window as any).GumroadOverlay;

  if (gumroadOverlay) {
    if (!gumroadOverlay.oldCreateIframe) {
      gumroadOverlay.oldCreateIframe = gumroadOverlay.createIframe;
    }

    gumroadOverlay.createIframe = function() {
      const currentLink = gumroadOverlay.links.find((link: any) => {
        return link.element.href === currentHref;
      });

      this.isSingleProductMode = true;

      if (currentLink) {
        currentLink.manager.currentLink = currentLink;
        this.oldCreateIframe();
        currentLink.manager.currentLink = undefined;
      } else {
        this.oldCreateIframe();
      }
    };
  }
};

const makeGumroadURL = (product: GumroadProduct, userId: number, email: string) => {
  return `https://gum.co/${product}?user_id=${userId}&email=${email}&wanted=true`;
};

export const SubscribeButton: React.FunctionComponent<SubscribeProps> = props => {
  useGumroadListener();
  const useInfo = useSelector(getUserProfile).userInfo!;

  if (!useInfo) {
    return null;
  }

  const url = makeGumroadURL(props.product, useInfo.id, useInfo.email);

  const trackSubscribe = () => {
    trackEvent('Subscribe_click', {
      product: props.product,
    });
  };

  return (
    <FormattedMessage id={props.messageId}>
      {message => {
        return (
          <Button
            href={url}
            target="_blank"
            onMouseEnter={setupGumRoadHook}
            onClick={trackSubscribe}
            color="grey"
            outline={true}
            block={true}
            data-gumroad-overlay-checkout="true"
            {...props}
          >
            {message}
          </Button>
        );
      }}
    </FormattedMessage>
  );
};



// WEBPACK FOOTER //
// ./src/components/MembershipSettings/SubscribeButton.tsx